import React, { useRef } from "react";
import styles from "./importFIle/ImportFile.module.scss";

const ImportFile = ({ onSubmit, handleSetSelectedFile }) => {

  const fileUploader = useRef(null);

  const handleFileChange = (event) => {
    const fullPath = fileUploader.current.value;
    handleSetSelectedFile(event.target.files[0]);
    const startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
    let filename = fullPath.substring(startIndex);
    if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
      filename = filename.substring(1);
    }
    onSubmit(filename);
  }

  const handleFileChoose = () => {
    fileUploader.current.click();
  }

  const dropHandler = (ev) => {
    ev.preventDefault();
    if (ev.dataTransfer.items) {
      for (let i = 0; i < ev.dataTransfer.items.length; i++) {
        if (ev.dataTransfer.items[i].kind === 'file') {
          let file = ev.dataTransfer.items[i].getAsFile();
          const startIndex = (file.name.indexOf('\\') >= 0 ? file.name.lastIndexOf('\\') : file.name.lastIndexOf('/'));
          let filename = file.name.substring(startIndex);
          if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
            filename = filename.substring(1);
          }
          onSubmit(filename);
        }
      }
    }
  }

  const dragOverHandler = (ev) => {
    console.log("File(s) dropped")
    ev.preventDefault();
  }

  return (
    <div className={styles.ImportWrapper}>
      <div id="dropContainer" onDrop={(event) => dropHandler(event)} onDragOver={(event) => dragOverHandler(event)} className={[styles.banner, 'd-flex align-items-center justify-content-center'].join(' ')}>
          <span>
            <svg width="120" height="109" viewBox="0 0 120 109" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M48.5139 31.0178C47.789 31.9969 47.8722 33.3936 48.7882 34.28C49.7632 35.255 51.3556 35.255 52.3307 34.28L57.4981 29.08V42.535H62.5032V29.08L67.6707 34.28L67.9509 34.5217C68.9301 35.2469 70.3268 35.1664 71.2131 34.28C71.7006 33.7925 71.9606 33.1425 71.9606 32.4925C71.9606 31.875 71.7006 31.225 71.2131 30.7375L61.7556 21.2475L61.4608 20.9826C61.0406 20.6664 60.5206 20.5 60.0006 20.5C59.3181 20.5 58.7006 20.76 58.2132 21.2475L48.7557 30.7375L48.5139 31.0178ZM41.2513 42.5516C33.6032 42.9129 27.5 49.3465 27.5 57.1843V73.3209L27.5157 74.0115C27.8708 81.7948 34.1959 88.0357 41.9625 88.0357H78.07L78.7487 88.0197C86.3968 87.6584 92.5 81.2239 92.5 73.354V57.2504L92.4842 56.5571C92.1274 48.7453 85.7725 42.5356 78.0375 42.5356H62.5025V62.3758L62.4793 62.7246C62.3113 63.9772 61.2513 64.9219 60 64.9219C58.6025 64.9219 57.4975 63.7976 57.4975 62.3758V42.5356H41.93L41.2513 42.5516Z" fill="#8A0FFF"/>
              </g>
              <circle cx="100.5" cy="37.5" r="2.5" fill="#C2C7ED"/>
              <circle cx="20.5" cy="45.5" r="2.5" fill="#E8EBFF"/>
              <circle cx="117.5" cy="62.5" r="2.5" fill="#E8EBFF"/>
              <circle cx="5.5" cy="26.5" r="2.5" fill="#F0F2FF"/>
              <circle cx="37.5" cy="34.5" r="2.5" fill="#C2C7ED"/>
              <circle cx="77.5" cy="9.5" r="2.5" fill="#8A0FFF"/>
              <circle cx="2.5" cy="72.5" r="2.5" fill="#8A0FFF"/>
              <circle cx="105.5" cy="82.5" r="2.5" fill="#8A0FFF"/>
              <defs>
                <filter id="filter0_d" x="1" y="-6" width="118" height="118" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                  <feOffset/>
                  <feGaussianBlur stdDeviation="10"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0.541176 0 0 0 0 0.0588235 0 0 0 0 1 0 0 0 0.3 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                </filter>
              </defs>
            </svg>
          </span>
      </div>
      <div className={styles.uploadArea}>
        <div>
          <input ref={fileUploader} type={'file'} onChange={handleFileChange} />
          Drop your file here. Or you can <span onClick={handleFileChoose}>Browse</span>
        </div>
        <div>
          <span>Supports .bpmn</span>
        </div>
      </div>
    </div>
  )
};

export default ImportFile;